// Nomes traduzidos do que o delegation log mostra por código (F4 da revisão do M6): as 14 tarefas do Anexo A.4 (`authz:delegations.taskNames.<CÓDIGO>`), as funções do catálogo
// do People (`functionNames`), os papéis de estudo (`studyRoleNames`) e as capacidades (`skillNames`). O `name` que o servidor devolve (hoje só em pt-BR) é o `defaultValue`:
// um código que o front ainda não conhece (tarefa nova do catálogo, função de outra versão) aparece com o nome do servidor ou, sem ele, com o próprio código.
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/** `(código, nome do servidor?) → nome no idioma ativo`. */
export type NameOf = (code: string, serverName?: string | null) => string;

function useNames(group: 'taskNames' | 'functionNames' | 'studyRoleNames' | 'skillNames'): NameOf {
  const { t } = useTranslation('authz');
  return useCallback<NameOf>(
    (code, serverName) => t(`delegations.${group}.${code}`, { defaultValue: serverName ?? code }),
    [t, group],
  );
}

/** Nome da tarefa delegável (Anexo A.4). */
export function useTaskName(): NameOf {
  return useNames('taskNames');
}

/** Nome da função exercida (catálogo de funções do People, Anexo E.3). */
export function useFunctionName(): NameOf {
  return useNames('functionNames');
}

/** Nome do papel de estudo (catálogo de papéis do AUTHZ). */
export function useStudyRoleName(): NameOf {
  return useNames('studyRoleNames');
}

/** Nome da capacidade (`Skill`) que uma tarefa exige. */
export function useSkillName(): NameOf {
  return useNames('skillNames');
}
